module.exports = __webpack_public_path__ + "img/bat_volt.1a1761d7.svg";